<ion-row class="body" [ngStyle]="{ 'background-color': 'rgba(0, 0, 0, ' + (level * 0.01) + ')' }">
    <ion-col size="2">
        <div [ngStyle]="{ 'margin-left': (level * 2) + 'px' }" class="colaborator-col">
            <ng-container *ngIf="userEvaluation.subordinates?.length > 0">
                <a (click)="userEvaluation.opened = true">
                    <span *ngIf="!userEvaluation.opened" class="bp-arrow-right-fill"></span>
                </a>
                <a (click)="userEvaluation.opened = false">
                    <span *ngIf="userEvaluation.opened" class="bp-arrow-bottom-fill"></span>
                </a>
            </ng-container>
            <img [ngStyle]="{ 'margin-left': userEvaluation.subordinates?.length > 0 
                                        ? (0+'px')
                                        : (20+'px'),
                              'background-color': 'rgb(255, 255, 255)'}"
                 [src]="getImageUrl(userEvaluation.imageUrl)" default="" class="avatar" alt=""/>
            <span *ngIf="userEvaluation.allSent === HeadEvaluationStatus.Sent"
                  [ngStyle]="{ 'left': userEvaluation.subordinates?.length > 0 ? 60+(level * 2)+'px' : 53+(level * 2)+'px'}"
                  class="bp-check-circle-fill" color="success"></span>
            <div class="user-info">
                <span>{{ userEvaluation.name }}</span>
                <span class="see-eval"
                      (click)="view360Review()">{{ 'headEvaluation.viewEvaluations' | translate }}</span>
            </div>
        </div>
    </ion-col>
    <ion-col [size]="colSize">
        <span>{{
                userEvaluation.selfEvaluationFinalConcept?.selfEvaluationFinalConcept
                    ? userEvaluation.selfEvaluationFinalConcept?.selfEvaluationFinalConcept
                    : '-'
            }}</span>
    </ion-col>
    <ng-container *ngFor="let area of areas">
        <ion-col [size]="colSize">
                <span>{{
                        userEvaluation.threeSixtyEvaluationFinalConcepts[area.id] !== null
                        && userEvaluation.threeSixtyEvaluationFinalConcepts[area.id]?.threeSixtyEvaluationFinalConcept
                            ? userEvaluation.threeSixtyEvaluationFinalConcepts[area.id]?.threeSixtyEvaluationFinalConcept
                            : '-'
                    }}</span>
        </ion-col>
    </ng-container>
    <ion-col [size]="colSize">
            <span>{{
                    userEvaluation.managerEvaluationFinalConcept?.managerEvaluationFinalConcept
                        ? userEvaluation.managerEvaluationFinalConcept?.managerEvaluationFinalConcept
                        : '-'
                }}</span>
    </ion-col>
    <ion-col size="1.25" flexed>
        {{ userEvaluation.initialFinalEvaluation }}
    </ion-col>
    <ion-col size="1.25" flexed>
        {{ userEvaluation.status ? userEvaluation.finalEvaluation : "" }}
        <ng-container *ngIf="userEvaluation.status === HeadEvaluationStatus.NotSent">
            <a (click)="editFinalAverage(userEvaluation)"><span class="bp-edit"></span></a>
        </ng-container>
        <ng-container *ngIf="userEvaluation.status === HeadEvaluationStatus.Sent && isRhOrAdmin">
            <span (click)="reopenAndEditFinalAverage(userEvaluation)" class="bp-user-check"></span>
        </ng-container>
    </ion-col>
    <ion-col size="1">
        <ng-container *ngIf="userEvaluation.status === HeadEvaluationStatus.Sent">
            <span class="bp-check"></span>
        </ng-container>
    </ion-col>
    <ng-container *ngIf="userEvaluation.opened && userEvaluation.subordinates?.length > 0">
        <ion-row class="subordinate-body" *ngFor="let subordinate of userEvaluation.subordinates">
            <app-subordinate-user-list
                    style="width: 100%;"
                    [areas]="areas"
                    [colSizeToAreas]="colSizeToAreas"
                    [colSize]="colSize"
                    [userEvaluation]="subordinate"
                    [level]="level + 5"
                    [cycleParticipantId]="cycleParticipantId"
                    [cycleId]="cycleId"
                    (getEvaluations)="getEvaluations.emit()">
            </app-subordinate-user-list>
        </ion-row>
    </ng-container>
</ion-row>
